import React, { Component, Children, cloneElement } from 'react';
import Element from './Element';
import Header from './Header';

class Multiple extends Element {
  state = {
    shownInstance: -1
  };

  sortDateList = true;

  addInstance() {
    const values = {};
    var instanceToShow = null;

    switch(this.props.path) {
      case '<gavedoc><patient><visit>':
        values[this.props.path] = [{'<gavedoc><patient><visit><date>': [new Date().toISOString().substr(0, 10)]}].concat(this.getValues(this.props.path));
        instanceToShow = 0;
      break;

      default:
        values[this.props.path] = this.getValues(this.props.path).concat([{}]);
        instanceToShow = values[this.props.path].length - 1;
      break;
    }

    this.props.setValues(values);

    this.setState({
      shownInstance: instanceToShow
    });
  }

  removeInstance(ix) {
    if (!window.confirm("Wollen Sie diesen Eintrag wirklich löschen?")) return;
    const values = {};
    values[this.props.path] = this.getValues(this.props.path).slice(0, ix).concat(this.getValues(this.props.path).slice(ix + 1));

    this.props.setValues(values);
  }

  setInstanceValues(map, ix) {
    const values = {};

    values[this.props.path] = this.getValues(this.props.path);
    values[this.props.path][ix] = Object.assign({}, values[this.props.path][ix], map);

    switch(this.props.path) {
      case '<gavedoc><patient><visit>':
        // only save visit values if instance matches (eg. edit mask is opened)
        if(this.state.shownInstance === ix) {
          this.props.setValues(values);
        }
      break;

      default:
        this.props.setValues(values);
      break
    }
  }

  toggleInstance(ix) {
    this.setSortFlag(true, true);

    this.setState({shownInstance: this.state.shownInstance === ix ? '-1' : ix});
  }

  setSortFlag(flag, forceRerender) {
    this.sortDateList = flag;

    if(forceRerender) {
      this.setState(this.state);
    }
  }

  getSortFlag() {
    return this.sortDateList;
  }

  getClonedChildren(el, value, ix) {
    return Children.map(el.props.children, field => {
      let newProps = {};

      if (!field) return;

      newProps = {
        key: field.props ? field.props.path + '-' + ix : '',
        values: value,
        setValues: (map) => this.setInstanceValues(map, ix),
      };

      if (field.type === Multiple) {
        return (
          <Multiple
            {...field.props}
            {...newProps}>{field.props.children}</Multiple>
        );
      }
      else if (field.type === Element) {
        return (
          <Element
            {...field.props}
            {...newProps}>{field.props.children}</Element>
        );
      }
      else if (field.type === Header) {
        const headerFields = this.getClonedChildren(field, value, ix);
        return (
          <div className="header flexbox-item flexbox-menu">
            <div className="tabs nav flex">
              <div className="left">
                <ul>
                  {headerFields.map((field, ix) => <li key={"header-field-" + ix}>{field}</li>)}
                </ul>
              </div>
              <div className="right">
                <ul className="actions">
                  <li className="level_1 first" onClick={() => this.toggleInstance(ix)}>
                    {ix !== this.state.shownInstance && 
                    <span>
                      <i className="fa fa-main fa-pencil"></i>
                      <span className="label">Edit</span>
                    </span>}
                    {ix === this.state.shownInstance && 
                    <span>
                      <i className="fa fa-main fa-check"></i>
                      <span className="label">Close</span>
                    </span>}
                  </li>
                  <li className="level_1 last" onClick={() => this.removeInstance(ix)}>
                    <i className="fa fa-main fa-trash"></i>
                    <span className="label">Delete</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );
      }
      
      if (field.props) {
        return cloneElement(field, Object.assign({}, {
          children: this.getClonedChildren(field, value, ix)
        }));
      }
      else {
        return field;
      }
    });
  }

  render() {
    const values = this.props.values[this.props.path] || [];

    const structure = this.getSubStructure(this.props.structure, this.props.path);
    const dateElement = structure.children.find(c => c.name === 'date');

    if (this.state.shownInstance == -1 && this.getSortFlag() && dateElement) {
      const datePath = this.props.path + '<' + dateElement.name + '>'
      values.sort((a, b) => {
        if (a && b) {
          const dateA = a[datePath];
          const dateB = b[datePath];

          if (dateA && dateB) {
            if (dateA < dateB) return 1;
            else if (dateA > dateB) return -1;
            else return 0;
          }
        }

        return 0;
      });
    }

    const instances = values.map((value, ix) => {
      return (<div className={"instance" + (ix !== this.state.shownInstance ? ' collapsed' : '')} orgix={ix} key={this.props.path + '-' + ix}>
        {this.getClonedChildren(this, value, ix)}
        </div>
      );
    });

    if(this.state.shownInstance == -1) {
      this.setSortFlag(false);
    }

    return (
      <div className="multiple">
        <div style={{display:'flex', alignItems: 'center', borderBottom: '1px solid #ebebeb', paddingBottom: '5px'}}>
          <h2 style={{flex: 1, marginBottom:0}}>{this.props.title}</h2>
          <div className="nav flex" style={{border:0, margin:0}}>
            <div className="left">
              <ul>
                <li
                  className="level_1 first last"
                  onClick={() => this.addInstance()}
                  style={{ borderTop: '1px solid #ddd', borderBottom: '1px solid #ddd'}}>
                  <i className="fa fa-main fa-plus"></i>
                  <span className="label">Add {this.props.instanceName}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {instances.length ? instances : <p>Keine Einträge.</p>}
      </div>
    )
  }
}

export default Multiple;



// WEBPACK FOOTER //
// ./src/Multiple.js